(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tt/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/modules/tt/assets/javascripts/prescript.js');

svs = svs || {};
(function(Backbone, _, svs) {
  'use strict';

  svs.tt = svs.tt || {};

  svs.tt.collections = svs.tt.collections || {};
  svs.tt.views = svs.tt.views || {};
  svs.tt.views.productviews = svs.tt.views.productviews || {};
  svs.tt.models = svs.tt.models || {};
  svs.tt.models.productdraws = svs.tt.models.productdraws || {};
  svs.tt.router = svs.tt.router || {};
  svs.tt.data = svs.tt.data || {};
})(Backbone, _, svs);


 })(window);